import { create } from 'zustand';

export type DevelopmentStatusScope = 'page' | 'modal';

interface DevelopmentStatusEntry {
  token: symbol;
  label: string;
  scope: DevelopmentStatusScope;
}

interface DevelopmentStatusState {
  entries: DevelopmentStatusEntry[];
  register: (label: string, scope: DevelopmentStatusScope) => () => void;
}

/** 화면이 열려 있는 동안만 유지하며, 영속 저장이나 인증용 개발 모드와 분리한다. */
export const useDevelopmentStatusStore = create<DevelopmentStatusState>((set) => ({
  entries: [],
  register: (label, scope) => {
    const token = Symbol('development-status');
    set((state) => ({ entries: [...state.entries, { token, label, scope }] }));

    // 같은 문구의 페이지·모달이 겹쳐도 해당 등록만 해제한다.
    return () => set((state) => ({ entries: state.entries.filter((entry) => entry.token !== token) }));
  },
}));
